module.exports = __webpack_public_path__ + "media/komodo-dragon.76d7eb57.mp3";